<template>
  <div class="Reports__View">
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>פרקי שאלות חשיפה</template>
      <template #button>
        <a @click="addExpoChapter" class="link-button">
          הוספת פרק שאלות חשיפה לקורס
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import CoursesService from "@/services/CoursesService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import ExpoChapterEntity from "@/views/ExpoChapterEntity.vue";
import DialogAddExpoChapter from '@/components/DialogAddExpoChapter.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    courseId() {
      return this.$store.state.auth.course.id;
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const lessonsFields = FieldService.list("expoChapters");

      const sideViewEntity = {
        component: ExpoChapterEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי פרק",
        recordUrl: "expoChapter",
        recordTitle: "הצג פרק",
      };
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.ExternalId, checked: true },
        { ...lessonsFields.DisplayName, checked: true },
        { ...lessonsFields.UnitDisplayNameText, checked: true },
        { ...lessonsFields.Status, checked: true },
        { ...lessonsFields.SortOrder, checked: true },
        { ...lessonsFields.LessonExerciseId, checked: true },
        { ...lessonsFields.ExpoType, checked: true },
        { ...lessonsFields.ExerciseCategoryName, checked: true },
        { ...lessonsFields.GroupName, checked: true },
        { ...lessonsFields.Entity, checked: true },
      ];

      this.tabs = [
        {
          id: "AllExpoChapters",
          isPrimary: true,
          title: "כל הפרקים",
          getDataAsync: this.getAllExpoChapters,
          perPage: 100,
          fields,
          filters: null,
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: false,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש לפי שם פרק",
          },
          sideViewEntity,
        },
      ];
    },
    addExpoChapter() {
      Modal.open({
        component: DialogAddExpoChapter,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllExpoChapters({ ...rest }) {
      return CoursesService.getCourseExpoChapters(this.courseId, rest).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
  },
};
</script>
<style scoped lang="scss">
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}
</style>
